<script>
import Dropdown from 'src/pc/components/Dropdown'
export default {
  extends: Dropdown
}
</script>

<style>
  .dropdown_wrap .dropdown {
    margin-top: 10px;
  }
  .dropdown_wrap .dropdown span {
    font-size: 13px;
    font-weight: 600;
    padding: 9px 15px;
    letter-spacing: 0;
  }
  .dropdown_wrap .dropdown span:after {
    width: 12px;
    height: 14px;
    margin-top: 0;
    margin-left: 8px;
  }
  .dropdown_wrap .dropdown_lst {
    width: calc(100vw - 40px);
    padding: 15px;
    border-radius: 0.5em;
    max-height: 100vw;
  }
  .dropdown_wrap .dropdown_lst li {
    display: block;
    font-size: 14px;
    font-weight: 500;
  }
  .dropdown_wrap .dropdown_lst li:hover {
    color: #379339;
    background: #fafafa;
  }
</style>
